import Layout from "../../../Components/Layout";
import EventListStepper from "../../../Components/User/Events/EventListStepper";
import UserEventList from "../../../Components/User/Events/UserEventList";

const UserMyEventListPage = () => {
  return (
    <Layout
      Heading="My Events"
      TitleMark="My"
      TitleMarkClassName="event-my-events-title-mark"
      TitleClassName="event-my-events-title"
      HeadClassName="event-my-events-head"
      ExtraclassName="event-my-events-panel"
      activeMenuId="my-events"
    >
      <div className="event-my-events-body">
        <EventListStepper />
        <UserEventList />
      </div>
    </Layout>
  );
};

export default UserMyEventListPage;
